import * as React from "react";
const SvgFiRrSellerStore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-seller-store_svg__a)">
      <path
        fill="#062147"
        d="M10 23a1 1 0 0 1-1 1H5c-2.206 0-4-1.794-4-4v-9.382A3.96 3.96 0 0 1 0 8q0-.14.039-.275l1.17-4.099A5.02 5.02 0 0 1 6.017 0h11.966a5.02 5.02 0 0 1 4.808 3.626l1.171 4.099q.038.135.039.275c0 .458-.077.907-.229 1.334a.999.999 0 1 1-1.885-.669q.092-.26.109-.539l-1.128-3.951a3.01 3.01 0 0 0-2.885-2.176H17v2a1 1 0 0 1-2 0v-2H9v2a1 1 0 0 1-2 0v-2h-.983a3.01 3.01 0 0 0-2.885 2.176L2.004 8.126A2.003 2.003 0 0 0 4 10h1c1.103 0 2-.897 2-2a1 1 0 0 1 2 0c0 .712.383 1.376 1.001 1.733a1.001 1.001 0 0 1-1.002 1.732 4 4 0 0 1-1.005-.84A3.98 3.98 0 0 1 5 12.001H4c-.347 0-.678-.058-1-.142v8.142c0 1.103.897 2 2 2h4c.552 0 1 .446 1 .999m14-6c0 3.859-3.14 7-7 7s-7-3.141-7-7 3.14-7 7-7 7 3.141 7 7m-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5m-3.192-1.241-2.223 2.134a.37.37 0 0 1-.522 0l-1.132-1.108a1 1 0 0 0-1.399 1.43l1.132 1.108a2.37 2.37 0 0 0 1.664.674c.602 0 1.201-.225 1.653-.671l2.212-2.124a1 1 0 1 0-1.385-1.443"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-seller-store_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSellerStore;
